export default {
    state: {
        assignableTags: [],
        courseId: null,
        key: null,
    },

    actions: {},
    mutations: {
        UPDATE_REFRESH_KEY(state, payload) {
            state.key += 1;
            state.courseId = payload;
        },
    },
};
